import shp from "@inovitas/shapefile-js";
async function loadBufferFromFile(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function (e) {
            resolve(e.target.result);
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
    });
}
/**
 * Converts a ESRI-Shapefile into a GeoJSON.
 * Uses the files *.shp, *.prj and *.dbf (prj and dbf is optional).
 * The files can be available seperately in the filefiled as well as in one zip archive.
 * @param filefield HTML File Field
 * @returns part of the layer configuration for a memory layer
 */
export async function shpToGeoJSONFromFileInput(filefield) {
    const files = filefield.files;
    // check if its a zip archive
    if (files.length == 1) {
        const file = files[0];
        if (file.type == "application/x-zip-compressed") {
            //its a zip-File
            const zipBuffer = await loadBufferFromFile(file);
            // the geojson is transformed to wgs coordinates if the prj-file contains the correct crs information for the data.
            const geojson = await shp(zipBuffer);
            return {
                data: geojson,
                title: geojson.fileName,
                srid: 4326,
            };
        }
    }
    if (files.length >= 1) {
        const filelist = [];
        for (let i = 0; i < files.length; i++) {
            filelist.push(files[i]);
        }
        const shapes = filelist.filter((file) => file.name.split(".").slice(-1)[0] == "shp");
        const projs = filelist.filter((file) => file.name.split(".").slice(-1)[0] == "prj");
        const dbfs = filelist.filter((file) => file.name.split(".").slice(-1)[0] == "dbf");
        if (shapes.length > 0) {
            const shape_buffer = await loadBufferFromFile(shapes[0]);
            const filename = shapes[0].name.split(".").slice(0, 1)[0];
            let srid = 4326;
            let proj_buffer;
            let checkwgscoords = true;
            if (projs.length > 0) {
                proj_buffer = await loadBufferFromFile(projs[0]);
            }
            let dbf_buffer;
            if (dbfs.length > 0) {
                dbf_buffer = await loadBufferFromFile(dbfs[0]);
            }
            let geojson;
            if (shape_buffer && proj_buffer && dbf_buffer) {
                geojson = await shp.combine([
                    shp.parseShp(shape_buffer, Buffer.from(proj_buffer)),
                    shp.parseDbf(dbf_buffer),
                ]);
            }
            else if (shape_buffer && proj_buffer) {
                geojson = await shp.combine([shp.parseShp(shape_buffer, Buffer.from(proj_buffer))]);
            }
            else if (shape_buffer && dbf_buffer) {
                geojson = await shp.combine([shp.parseShp(shape_buffer), shp.parseDbf(dbf_buffer)]);
                //srid -1 = no transformation is applied while importing the data into a memory-layer.
                //We assume that the data is available in the crs infra3d uses.
                srid = -1;
                checkwgscoords = false;
            }
            else {
                geojson = await shp.combine([shp.parseShp(shape_buffer)]);
                srid = -1;
                checkwgscoords = false;
            }
            return {
                data: geojson,
                title: filename,
                srid: srid,
            };
        }
    }
}
//# sourceMappingURL=shp.js.map